/**
 * Сервис для получения массива firstPaymentDefinition из всех tourProduct.
 * @param tourProducts
 * @returns {*[]|*}
 */
export default (tourProducts) => {
    if (!tourProducts?.length) {
        return [];
    }

    return tourProducts.reduce((acc, tourProduct) => {
        const allFirstPaymentDefinitions = tourProduct.get('allFirstPaymentDefinitions');

        _.each(allFirstPaymentDefinitions, (firstPaymentDefinition) => {
            const isAddedItem = _.findWhere(acc, {
                id: firstPaymentDefinition.id,
            });

            if (!_.isEmpty(firstPaymentDefinition) && !isAddedItem) {
                acc.push({
                    ...firstPaymentDefinition,
                    operatorName: tourProduct.get('tour')?.get('operator')?.name || '',
                });
            }
        });

        return acc;
    }, []);
};
